export default __webpack_public_path__ + "static/IDC-5f17258e6ec4983250c77711a3b6f45c.png";